import { dateTime, time } from '@/lib/date/util'
import { useTranslation } from 'react-i18next'

/**
 * 現在の i18n 言語設定に基づいて ISO 8601 日付文字列を整形する hook。
 *
 * @example
 * const { formatDate } = useFormatDate()
 * formatDate('2026-03-01T10:00:00+09:00')
 * // ja_JP → "2026年03月01日"
 * // en_US → "03/01/2026"
 * // en_SG → "01/03/2026"
 * // ko_KR → "2026년03월01일"
 *
 * formatDateTime('2026-03-01T10:00:00+09:00')
 * // ja_JP → "2026/03/01 10:00"
 * // en_US → "03/01/2026 10:00"
 * // en_SG → "01/03/2026 10:00"
 */
export const useFormatDate = () => {
  const { i18n } = useTranslation()
  const language = i18n.language ?? 'ja_JP'

  const formatDate = (isoString: string): string => {
    return time({ time: isoString, language }) ?? isoString
  }

  /** 日付 + 時刻（HH:mm）。前回のログイン日時（#3635）など時刻まで見せたい場面で使う */
  const formatDateTime = (isoString: string): string => {
    return dateTime({ time: isoString, language }) ?? isoString
  }

  return { formatDate, formatDateTime }
}
